import { render, staticRenderFns } from "./ExportedTable.vue?vue&type=template&id=c4135d9a&"
import script from "./ExportedTable.vue?vue&type=script&lang=ts&"
export * from "./ExportedTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports